import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { Dialog, DialogProps } from '@producer/ui-kit';

import { VersionManagerItem } from './version-manager-item';
import { Asset } from '../../../app/entities';

interface VersionManagerProps extends DialogProps {
  asset: Asset;
  selectedVersion: string;
}

export const VersionManager: React.FC<VersionManagerProps> = observer(
  ({ asset, selectedVersion, onClose }) => (
    <Dialog title="Version manager" onClose={onClose}>
      <ModalContent>
        {asset.sortedChildren.map((version) => (
          <VersionManagerItem
            key={version._id}
            isSelected={selectedVersion === version._id}
            version={version}
            canDelete={asset.children.length > 1}
          />
        ))}
      </ModalContent>
    </Dialog>
  ),
);

const ModalContent = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 64rem;
  max-height: min(80vh, 500px);
  overflow: auto;
`;
